// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__5gy9W","title":"Header_title__eyDaV"};